import { Changelog } from "./layout/Changelog/Changelog"
import { Versions } from "./layout/Versions/Versions"

type Props = { menuItemIndex: number }

export const Content = ({ menuItemIndex }: Props) => {
	switch (menuItemIndex) {
		case 0:
			return <Versions />
		case 1:
			return <Changelog />
		default:
			return <Versions />
	}
}
